import { combineReducers } from "redux";
import ProcessReducer from './process/reducer'

export default combineReducers({
    process: ProcessReducer
});